// Throw redux-form error, to make the form error handling mechanism
// provided from redux-form work with submission errors too.
// {@link https://redux-form.com/7.4.2/docs/api/submissionerror.md/}
import { SubmissionError } from 'redux-form';

export const catchFormErrors = (error) => {
  throw new SubmissionError({ _error: error.message });
};



// WEBPACK FOOTER //
// ./src/utils/form-errors.js